import Footer from "../Components/Layout/Footer";
import NavBar from "../Components/Layout/NavBar";

const MainLayout = ({ children }) => {
    return (
        <div style={{backgroundColor: '#00c1de', height: '100vh'}} className="main-layout">
            <NavBar />
            {children}
            <Footer />
        </div>
    );
}

export default MainLayout;